import { FC, useEffect, useState } from 'react'
import CardTAG from '../../CardTAG'
import FormLayout from '../../forms/FormLayout'
import { Box, TextField, TextareaAutosize, Typography } from '@mui/material'
import TableTAG from '../../TableTAG'
import { IFile } from '../../AttachmentsCase/types'
import { uploadInputZones } from '../../UploadDropzone/types'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import DescriptionIcon from '@mui/icons-material/Description'
import { resolveFileType } from '../../AttachmentsCase/DataPart'
import timeUtils from '../../../utils/timeUtils'
import { ITimelineEvent, eventTypes } from '../../CaseTimeline/types'
import eventsService from '../../../services/eventsService'
import MaterialMetadata from '../../MaterialMetadata'
import LabelErrorTAG from '../../LabelErrorTAG'
import { textAreaStyle } from '../../../constants/styleConstants'
import { useNavigate } from 'react-router-dom'
import reportsSelectors from '../../../store/reports/reportsSelectors'
import { renderPageUpdate } from '../../CaseTimeline/CaseTimelineDataPart'
import { useSelector } from 'react-redux'

import materialSelectors from '../../../store/materials/materialSelectors'


const CaseUpdates: FC<{ selectedReport: any }> = ({ selectedReport }) => {
  const reportAdditionalMaterials = useSelector(materialSelectors.getAdditionalMaterials)
  const [timelineEvents, setTimelineEvents] = useState<ITimelineEvent[]>([])
  const [selectedFile, setSelectedFile] = useState<IFile>()
  const selectedReportTypes = useSelector(reportsSelectors.reportCaseTypes)
  const navigate = useNavigate()

  const getCaseEvents = async () => {
    const { data } = await eventsService.getEvents(selectedReport?.id)
    const promises = data?.map(async (timelineEvent: ITimelineEvent) => {
      return await eventsService.getContent(timelineEvent.id, timelineEvent.type).then(res => {
        return { ...timelineEvent, files: res.data }
      })
    })
  
    Promise.all(promises).then(res => {
      setTimelineEvents(res)
    })
  }

  const handleSelect = (data: IFile) => {
    setSelectedFile(data)
  }

  useEffect(() => {
    if (selectedReport?.id) {
      getCaseEvents()
    }
  }, [selectedReport, reportAdditionalMaterials?.length])

  if (timelineEvents.length && timelineEvents.length > 0) {
    // eslint-disable-next-line no-console
    return (
      <>
        {timelineEvents.map((timelineEvent, id) => {
          const cls =
            timelineEvent?.type !== eventTypes.MATERIAL_ADDED &&
            timelineEvent.files?.questions &&
            timelineEvent.files?.questions.length === 0
              ? 't-d-none'
              : ''
          const clsM =
            timelineEvent?.type === eventTypes.MATERIAL_ADDED &&
            timelineEvent.files?.type !== uploadInputZones.TEXT_FIELD &&
            timelineEvent.files?.type !== uploadInputZones.LINK &&
            !timelineEvent.files?.description &&
            timelineEvent.files?.files &&
            timelineEvent.files.files.length === 0
              ? 't-d-none'
              : ''
          return timelineEvent.type !== eventTypes.EDIT ? (
            <CardTAG
              className={`${clsM}`}
              key={id}
              title={`${timeUtils.formatTimelineDate(
                timelineEvent.created_at,
              )} ${timeUtils.getTimeFromDate(timelineEvent.created_at)}`}
            >
              <FormLayout>
                <Typography variant='textMedium'>
                  User uploaded additional material to report.
                </Typography>
                {timelineEvent?.files?.type !== uploadInputZones.TEXT_FIELD &&
                  timelineEvent?.files?.type !== uploadInputZones.LINK && (
                    <div
                      className='t-font-size-xs'
                      dangerouslySetInnerHTML={{
                        __html: timelineEvent?.files?.description as string,
                      }}
                    ></div>
                  )}
                {timelineEvent.files?.type === uploadInputZones.TEXT_FIELD && (
                  <div className='t-field t-vbox'>
                    <LabelErrorTAG label={'Description'} />
                    <TextareaAutosize
                      value={timelineEvent.files.description}
                      readOnly
                      minRows={5}
                      style={textAreaStyle}
                      disabled
                    />
                  </div>
                )}
                {timelineEvent.files?.type === uploadInputZones.LINK && (
                  <div className='t-field t-vbox'>
                    <LabelErrorTAG label={'Link'} />
                    <TextField value={timelineEvent.files.link} disabled />
                  </div>
                )}
                {!!timelineEvent?.files?.files.length && (
                  <TableTAG
                    columns={[
                      {
                        id: 'preview',
                        label: 'Preview',
                        format: (_: any, row: IFile) => {
                          let url = ''
                          if (row instanceof File) {
                            url = URL.createObjectURL(row)
                          }
                          const typeToCheck = row?.extension ?? row?.extension
                          const getBoxStyle = (iconStyle: any) => (
                            <Box sx={{ width: '10rem', height: '10rem' }}>{iconStyle}</Box>
                          )

                          const getMediaElement = (src: string) => (
                            <img
                              src={src}
                              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                            />
                          )

                          if (row?.extension === uploadInputZones.TEXT_FIELD) {
                            return getBoxStyle(
                              <TextFieldsIcon sx={{ width: '100%', height: '100%' }} />,
                            )
                          }

                          if (
                            resolveFileType(typeToCheck) == uploadInputZones.DOCUMENT
                          ) {
                            return (
                              <Box sx={{ width: '10rem', height: '10rem' }}>
                                  <DescriptionIcon sx={{ width: '100%', height: '100%' }} />
                                
                              </Box>
                            )
                          }

                          
                          if (resolveFileType(typeToCheck) === uploadInputZones.AUDIO) {
                            return getBoxStyle(
                              <AudioFileIcon sx={{ width: '100%', height: '100%' }} />,
                            )
                          }

                          if (resolveFileType(typeToCheck) === uploadInputZones.VIDEO) {
                            return (
                              <Box sx={{ width: '10rem', height: '10rem' }} id='video'>
                                <video
                                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                >
                                  <source src={row instanceof File ? url : row?.link}></source>
                                </video>
                              </Box>
                            )
                          }

                          if (row?.link) {
                            
                            return getBoxStyle(
                              getMediaElement(row instanceof File ? url : row?.link),
                            )
                          }

                          return getBoxStyle(getMediaElement(row instanceof File ? url : row?.link))
                        },
                      },
                      { id: 'name', label: 'File Name' },
                      // { id: 'extension', label: 'File Type' },
                    ]}
                    pagination={false}
                    onRowClick={handleSelect}
                    rows={timelineEvent?.files?.files}
                  />
                )}
              </FormLayout>
            </CardTAG>
          ) : (
            renderPageUpdate(timelineEvent, navigate, selectedReportTypes, cls)
          )
        })}
        <MaterialMetadata
          opened={!!selectedFile}
          close={() => {
            setSelectedFile(undefined)
          }}
          material={selectedFile}
        />
      </>
    )
  }

  return <></>
}

export default CaseUpdates
